import useProfileUpdate from '../hooks/useProfileUpdate'
import { Grid } from '@mui/material'
import { Input } from '../../../common/form/input'
import styled from 'styled-components'
import React from 'react'
import { AutoCompleteSingleOption } from 'common/form/autocompleteSingleOption'
import { AlternativeAutoComplete } from 'common/form/autoComplete/_alternativeAutoComplete'

const InfoBank = () => {
    const { value, functions, bankName } = useProfileUpdate()
    const data = value?.userData;

    return (
        <StyledInfoBank>
            <Grid container spacing={2}>
                <Grid xs={6} sm={6} md={6} lg={6} item>
                    <div className="product-info-basic__form-input ">
                        <Input
                            label={'Số tài khoản'}
                            value={data?.bank_number || ''}
                            onChange={e => functions.onChangeBankNumber(e.target?.value)}
                            placeholder={'Vui lòng nhập số tài khoản'}
                        />
                    </div>
                </Grid>
                <Grid xs={6} sm={6} md={6} lg={6} item>
                    <div className="product-info-basic__form-input ">
                        <Input
                            label={'Chủ tài khoản'}
                            value={data?.bank_owner}
                            onChange={e => functions.onChangeBankOwner(e.target?.value)}
                            placeholder={'Vui lòng nhập chủ tài khoản'}
                        />
                    </div>
                </Grid>
                <Grid xs={6} sm={6} md={6} lg={6} item>
                    <div className="product-info-basic__form-input ">
                        <AlternativeAutoComplete
                            inputProps={{
                                categoryList: [],
                                categoryHidden: true,
                                readOnly: true,
                                categoryValue: {name: 'Vui lòng chọn ngân hàng', value: ''},
                                label: <>Ngân hàng</>,
                                placeholder: 'Vui lòng chọn ngân hàng',
                                value: bankName?.value?.name,
                            }}
                            menuProps={{
                                empty:
                                    bankName?.list?.length <= 0
                                    ? 'Không tìm thấy ngân hàng'
                                    : '',
                            }}
                            searchInputProps={{
                                placeholder: 'Tìm kiếm ngân hàng',
                                onChange: bankName?.methods?.onKeywordChange,
                            }}
                        >
                            {bankName?.list?.length > 0 &&
                                bankName.list.map((item, i) => (
                                <AutoCompleteSingleOption
                                    key={item.id}
                                    data-active={item.id === bankName?.value?.id}
                                    onClick={() => bankName?.methods?.onChange(item)}
                                >
                                    {item?.name}
                                </AutoCompleteSingleOption>
                            ))}
                        </AlternativeAutoComplete>
                    </div>
                </Grid>
            </Grid>
        </StyledInfoBank>
    )
}

export default InfoBank

export const StyledInfoBank = styled.div``